import { cn } from "../../../lib/utils/cn";
import { vw } from "../../../lib/utils/responsiveUtils";

interface SelectProps extends React.ComponentProps<"select"> {
  options: { label: string; value: string; disabled?: boolean }[];
  className?: string;
  placeholder?: string;
}

export default function SelectBox({
  className,
  options,
  placeholder,
  value,
  ...props
}: SelectProps) {
  const hasValue = value !== undefined && value !== "";

  return (
    <div className="relative inline-block w-full">
      {/* <select className={cn("appearance-none block border border-[#e6e6e6] px-[18px] py-[20px] w-full rounded-[10px]", className)} {...props}> */}
      <select
        className={cn(
          "appearance-none block border border-[#e6e6e6] px-[20px] w-full rounded-[10px] h-[50px] py-0 text-[14px]  disabled:bg-gray-100 disabled:text-gray-400",
          className,
        )}
        value={value}
        {...props}
      >
        {/* <select className={cn("appearance-none block w-full rounded-[10px] border border-[#e6e6e6] bg-white","px-[18px] pr-[44px] h-[50px] py-0 leading-[1.2] text-[14px]", className)}value={value}{...props}> */}
        {options.map(({ label, value }, index) => (
          <option key={index} value={value}>
            {label}
          </option>
        ))}
      </select>

      {!hasValue && placeholder && (
        <span
          className="pointer-events-none absolute inset-y-0 left-[17px] flex items-center text-[#ccc] font-[500]"
          style={{ fontSize: vw(14) }}
        >
          {placeholder}
        </span>
      )}

      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-[20px]">
        <img className="w-[14px] h-[6px]" src="/icons/ic-dropdown.webp" />
      </div>
    </div>
  );
}
